import { render, staticRenderFns } from "./compartirUsuario.vue?vue&type=template&id=dd35e2a2"
import script from "./compartirUsuario.vue?vue&type=script&lang=js"
export * from "./compartirUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports